import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PageLoader from '../components/global/PageLoader';
import pilotlyCeruleanLogo from '../assets/landing/pilotly_svg_logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import '../static/register/AmazonReadyToBegin.css';
import { FormattedMessage } from 'react-intl';

class AmazonReadyToBegin extends Component {
	render() {
		let { continueRegistration, groupPoster, welcomeDisplay } = this.props;

		return (
			<div className='amazon-branding'>
				<div className={"pilotly-register-form p-0 pt-40 pb-10" + (groupPoster ? "" : " m-auto pull-none")}>
					<div className='qualtrics amazon-title-wrapper mb-20'>
						<h1 className="begin-title m-0">{welcomeDisplay.title}</h1>
					</div>

					<div className='qualtrics amazon-message-wrapper'>
						<p className="begin-message">{welcomeDisplay.message}</p>
					</div>

					<button className={"waves-effect waves-light btn default-btn qualtrics begin-registration text-capitalize" + (continueRegistration ? "" : " form-lock")}
						onClick={continueRegistration ?
							() => this.props.enableRegistration()
							:
							null}>
						<PageLoader loading={!continueRegistration} small={true} />

						{welcomeDisplay.ctaButton} <FontAwesomeIcon className="qualtrics-angle-right" icon={faAngleLeft} />
					</button>
				</div>

				{/* <div className='text-align-left mb-10'>
					<Link to="https://www.amazon.com/hz/contact-us/foresight/hubgateway"
						target="_blank">
						<u>
							<FormattedMessage
								id="qualtrics.ready_to_begin.contact_amazon"
								defaultMessage={`Contact Amazon for help`}
							/>
						</u>
					</Link>
				</div> */}

				<div className='pilotly-message'>
					<div className='participation'>
						<FormattedMessage
							id="qualtrics.ready_to_begin.proprietary_information"
							defaultMessage={`*This survey contains proprietary information which may include confidential information. Participation in this survey does not convey any rights to reproduce or distribute its contents. Any reproduction or distribution of this survey or its contents without express written consent is strictly prohibited.`}
						/>
					</div>

					<div className='pilotly-logo'>
						<img className="width-100p noselect" src={pilotlyCeruleanLogo} alt='Pilotly' />
					</div>
				</div>
			</div>
		);
	}
}

export default AmazonReadyToBegin;


// WEBPACK FOOTER //
// ./src/pages/QualtricsReadyToBegin.js